import { render, staticRenderFns } from "./contactLog.vue?vue&type=template&id=04ff218b&scoped=true"
import script from "./contactLog.vue?vue&type=script&lang=js"
export * from "./contactLog.vue?vue&type=script&lang=js"
import style0 from "./contactLog.vue?vue&type=style&index=0&id=04ff218b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ff218b",
  null
  
)

export default component.exports